export default "__VITE_ASSET__BIcvl9Ru__"